module.exports = __webpack_public_path__ + "img/logo_only.537dee43.png";